import { render, staticRenderFns } from "./FormStatisticProfitChart.vue?vue&type=template&id=12ec5658&"
import script from "./FormStatisticProfitChart.vue?vue&type=script&lang=js&"
export * from "./FormStatisticProfitChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports